var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldCheckSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 19 20",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(1 1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 9.5 1.5 1.5 3-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 7.76700257c0 4.42554303 2.74719841 8.38615323 6.89228 9.93655003l.03007.01125c1.01751997.3805882 2.13837145.380233 3.15565-.001l.02436-.00913c4.1488046-1.5548061 6.89764-5.5204642 6.89764-9.95104003v-3.7234c0-.87487647-.568631-1.64821433-1.40372-1.90905l-6.5-2.03023c-.38826431-.12127009-.80427569-.12127009-1.19254 0l-6.5 2.03017c-.83509689.26082854-1.40374 1.0341681-1.40374 1.90905z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckSecond);
export default __webpack_public_path__ + "static/media/shield-check-second.5fee1851b62d3d74b18ed2a447f3ede4.svg";
export { ForwardRef as ReactComponent };